import { render, staticRenderFns } from "./ContestFinish.vue?vue&type=template&id=06453f4e&scoped=true"
import script from "./ContestFinish.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestFinish.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06453f4e",
  null
  
)

export default component.exports